// First: the startup watchdog listens for errors while the rest of the app's modules evaluate.
import { showCrashScreen } from './ui/shell/bootWatchdog';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './ui/theme/global.css';
import { App } from './App';
import { settingsStore } from './settings';
import { startBootstrap } from './ui/shell/bootstrap';
import { installGlobalErrorHooks, rootErrorOptions } from './ui/shell/errorReporter';
import { initLayout } from './ui/theme/layout';
import { applyTheme } from './ui/theme/themeMode';

// Global error hooks first (Flutter installs them before runApp, SHELL-026).
installGlobalErrorHooks();

// Theme before the first frame (Flutter loads theme_mode when ThemeProvider is created).
applyTheme(settingsStore.get().theme);
// Phone or desktop layout, also before the first frame; it follows window resizes from then on.
initLayout();
void startBootstrap();

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');

// An error no boundary caught unmounts the whole tree: show the recovery screen instead of a blank page.
createRoot(root, {
  ...rootErrorOptions,
  onUncaughtError: (error, info) => {
    rootErrorOptions.onUncaughtError?.(error, info);
    showCrashScreen();
  },
}).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
